import { Injectable, computed, signal } from '@angular/core';

type FeedbackDialogStatus = 'closed' | 'open' | 'success';
type FeedbackSubmissionStatus = 'idle' | 'submitting' | 'uploading-attachments' | 'success' | 'error';

@Injectable({
  providedIn: 'root',
})
export class FeedbackStateStore {
  private readonly status = signal<FeedbackDialogStatus>('closed');
  private readonly submissionStatus = signal<FeedbackSubmissionStatus>('idle');
  private readonly submissionError = signal<string | null>(null);

  readonly isOpen = computed(() => this.status() !== 'closed');
  readonly isSuccess = computed(() => this.status() === 'success');
  readonly submissionStatusSnapshot = computed(() => this.submissionStatus());
  readonly submissionErrorSnapshot = computed(() => this.submissionError());

  open(): void {
    this.clearSubmissionOutcome();
    this.status.set('open');
  }

  close(): void {
    this.status.set('closed');
    this.clearSubmissionOutcome();
  }

  markSuccess(): void {
    this.submissionError.set(null);
    this.submissionStatus.set('success');
    this.status.set('success');
  }

  markFailure(message: string): void {
    this.submissionError.set(message);
    this.submissionStatus.set('error');
    this.status.set('open');
  }

  markSubmitting(): void {
    this.submissionStatus.set('submitting');
    this.submissionError.set(null);
  }

  markUploadingAttachments(): void {
    this.submissionStatus.set('uploading-attachments');
    this.submissionError.set(null);
  }

  private clearSubmissionOutcome(): void {
    this.submissionStatus.set('idle');
    this.submissionError.set(null);
  }
}
